import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

const getToken = () => {
  const user = JSON.parse(localStorage.getItem('usr') || '{}');
  return user?.accessToken || '';
};

export const getVolumen = async (data: any) => {
  try {
    const token = getToken();
    const response = await axios.post(`${API_BASE}/peso/volumen`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error en getVolumen:", error);
    throw error;
  }
};

export const getVariaciones = async (data: any) => {
  try {
    const token = getToken();
    const response = await axios.post(`${API_BASE}/peso/variaciones`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error en getVariaciones:", error);
    throw error;
  }
};

export const getAlertasMonitoreo = async (data: any) => {
  try {
    const token = getToken();
    const response = await axios.post(`${API_BASE}/peso/alertas`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en getAlertasMonitoreo:", error);
    throw error;
  }
};


export const getAlertasProcesadas = async ({ fecha }: { fecha: string }) => {
  try {
    const token = getToken();
    const response = await axios.post(`${API_BASE}/peso/alertas-procesadas`, { fecha }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || [];
  } catch (error) {
    console.error('Error en getAlertasProcesadas:', error);
    return [];
  }
};
